import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RoleBadge from "../../components/RoleBadge";
import Layout from "../../components/layout/Layout";
import "./ViewContactPage.css";

export const ViewContactPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [contact, setContact] = useState(null);

  useEffect(() => {
    if (location.state?.contact) {
      setContact(location.state?.contact);
    }
  }, [location.state?.contact]);

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <>
      <Layout className="bg-black" showSideNav={false}>
        <div className="view-contact-container">
          <div className="view-contact-header">
            <h1 className="view-contact-title">
              <span style={{ marginRight: "48px" }}>View contact</span>
              <RoleBadge role={contact?.contactRole} />
            </h1>
          </div>

          <div className="card">
            <h2 className="details-title">Contact details</h2>
            <table className="details-table">
              <tbody>
                <tr>
                  <th>First name</th>
                  <td>{contact?.firstName || contact?.first_name || ""}</td>
                </tr>
                <tr>
                  <th>Last name</th>
                  <td>{contact?.lastName || contact?.last_name || "-"}</td>
                </tr>
                <tr>
                  <th>Contact type</th>
                  <td style={{ textTransform: "capitalize" }}>
                    {contact?.contactTypes}
                  </td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{contact?.email}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <Box sx={{ mb: 4, mx: 3, display: "flex", justifyContent: "flex-end" }}>
          <button className="close-button" onClick={handleClose}>
            <strong>Close</strong>
          </button>
        </Box>
      </Layout>
    </>
  );
};
